import cn from 'classnames';
import { useState, ReactNode } from 'react';
import { animated, useTransition } from 'react-spring';
import { TRANSITION_CONFIG } from './constants';
import styles from './tooltip_btn.module.scss';

interface IToolTipButton {
    icon: ReactNode;
    text: string;
    children?: ReactNode;
    className?: string;
    onClick?: () => void;
    tooltipPosition?: 'top' | 'bottom';
}

export default function ToolTipButton({
    icon,
    text,
    children,
    className = '',
    onClick,
    tooltipPosition = 'top',
}: IToolTipButton): JSX.Element {
    const [showTooltip, setShowToolTip] = useState<boolean>(false);

    const transitions = useTransition(showTooltip, {
        from: TRANSITION_CONFIG[tooltipPosition].from,
        enter: TRANSITION_CONFIG[tooltipPosition].to,
        leave: TRANSITION_CONFIG[tooltipPosition].from,
    });

    const toggleTooltip = (state: boolean): void => {
        setShowToolTip(state);
    };

    return (
        <button
            className={cn(styles.button, className)}
            onClick={onClick}
            onMouseEnter={() => toggleTooltip(true)}
            onMouseLeave={() => toggleTooltip(false)}
        >
            {transitions(
                (style, item) =>
                    item && (
                        <animated.div style={style} className={styles.tooltip}>
                            {children}
                        </animated.div>
                    ),
            )}

            {icon}
            <span>{text}</span>
        </button>
    );
}
